export default __webpack_public_path__ + "static/media/phone-youtube.de4dd9ec.png";